export enum EntityType {
    LLC = 0,
    Partnership = 1,
    SCorporation = 2,
    CCorporation = 3,
}

export const EntityTypeDescriptions: Record<EntityType, string> = {
    [EntityType.LLC]: 'Limited Liability Company (LLC)',
    [EntityType.Partnership]: 'Partnership',
    [EntityType.SCorporation]: 'S Corporation',
    [EntityType.CCorporation]: 'C Corporation',
};
